export const STATUS_COLORS: Record<string, string> = {
  CREATED: '#FF5E5E',
  READY_TO_PROCESS: '#FF9F00',
  IN_PROGRESS: '#0D99FF',
  PROJECT_PREPARING: '#FACC15',
  INSTALLATION_WORKS: '#3BD5DF',
  EXECUTED: '#3AC776',
  DONE: '#A8ACB0',
  DELAYED: '#FF6B6B',
  REJECTED: '#FF4D4D',
  CANCELLED: '#9E9E9E',
  APPROVED: '#4CAF50',
  NOTIFYING: '#2196F3',
  NONE: '#CCCCCC',
} as const;

export const STATUS_LABELS: Record<string, string> = {
  CREATED: 'Создана',
  READY_TO_PROCESS: 'Готова к исполнению',
  IN_PROGRESS: 'Выполняется',
  PROJECT_PREPARING: 'Подготовка проекта',
  INSTALLATION_WORKS: 'Монтаж оборудования',
  EXECUTED: 'Выполнена',
  DONE: 'Завершена',
  DELAYED: 'Задержана',
  REJECTED: 'Отклонена',
  CANCELLED: 'Отменена',
  APPROVED: 'Одобрена',
  NOTIFYING: 'Уведомление',
  NONE: 'Нет статуса',
  ALL: 'Все',
} as const;

export const STATUS_OPTIONS_MAP = {
  CREATED: {value: 'CREATED', label: STATUS_LABELS.CREATED},
  READY_TO_PROCESS: {value: 'READY_TO_PROCESS', label: STATUS_LABELS.READY_TO_PROCESS},
  IN_PROGRESS: {value: 'IN_PROGRESS', label: STATUS_LABELS.IN_PROGRESS},
  PROJECT_PREPARING: {value: 'PROJECT_PREPARING', label: STATUS_LABELS.PROJECT_PREPARING},
  INSTALLATION_WORKS: {value: 'INSTALLATION_WORKS', label: STATUS_LABELS.INSTALLATION_WORKS},
  EXECUTED: {value: 'EXECUTED', label: STATUS_LABELS.EXECUTED},
  DONE: {value: 'DONE', label: STATUS_LABELS.DONE},
  DELAYED: {value: 'DELAYED', label: STATUS_LABELS.DELAYED},
  REJECTED: {value: 'REJECTED', label: STATUS_LABELS.REJECTED},
  CANCELLED: {value: 'CANCELLED', label: STATUS_LABELS.CANCELLED},
  APPROVED: {value: 'APPROVED', label: STATUS_LABELS.APPROVED},
  NOTIFYING: {value: 'NOTIFYING', label: STATUS_LABELS.NOTIFYING},
  NONE: {value: 'NONE', label: STATUS_LABELS.NONE},
  ALL: {value: 'ALL', label: STATUS_LABELS.ALL},
} as const;

export const STATUS_OPTIONS = Object.values(STATUS_OPTIONS_MAP);

export const STATUS_VALUES = {
  CREATED: 'CREATED',
  READY_TO_PROCESS: 'READY_TO_PROCESS',
  IN_PROGRESS: 'IN_PROGRESS',
  PROJECT_PREPARING: 'PROJECT_PREPARING',
  INSTALLATION_WORKS: 'INSTALLATION_WORKS',
  EXECUTED: 'EXECUTED',
  DONE: 'DONE',
  DELAYED: 'DELAYED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
  APPROVED: 'APPROVED',
  NOTIFYING: 'NOTIFYING',
  NONE: 'NONE',
  ALL: '',
} as const;

export const CIRCLE_STATUSES = {
  DONE: {
    color: '#C64CFF',
    label: 'Заявка завершена в срок',
  },
  COMPLETED_NOT_CLOSED: {
    color: '#0D99FF',
    label: 'Выполнена, но не завершена',
  },
  ACTIVE_NO_URGENCY: {
    color: '#3AC977',
    label: 'Заявка в работе',
  },
  EXPIRING_SOON: {
    color: '#FF9F00',
    label: 'До срока завершения менее 14 дней',
  },
  OVERDUE_EXISTS: {
    color: '#FF5E5E',
    label: 'Срок завершения просрочен',
  },
  EMPTY: {
    color: '#CCCCCC',
    label: 'Не заполнено',
  },
} as const;
